import { Fetcher } from "@/utils/fetcher";

const auth = new Fetcher("auth");
const user = new Fetcher("user");
const mail = new Fetcher("mail");
const updatedUser = new Fetcher("auth/user");

// validate token
export const validateToken = (token: string) =>
  new Fetcher("auth", undefined, token).get<User>("/validate-token");

// login
export const loginWithPhone = (data: LoginRequest) =>
  auth.post<AuthResponse>("/front/customer/login", data);

// register
export const registerCustomer = (data: RegesterRequest) =>
  auth.post<AuthResponse>("/front/customer/register", data);

// sent otp: {{apiUrl}}/api/v1/auth/customer/send-otp
export const sendOtp = (data: SendOtpRequest) =>
  auth.post<SendOtpResponse>("/customer/forget-password/send-otp", data);

// otp login: {{apiUrl}}/api/v1/auth/customer/otp-login
export const otpLogin = (data: OtpLoginRequest) =>
  auth.post<AuthResponse>("/customer/otp-login", data);

// password reset (OTP): {{apiUrl}}/api/v1/auth/customer/password-reset
export const resetPassword = (data: ResetPasswordRequest) =>
  auth.patch("/customer/forget-password/verify-otp", data);

// {{apiUrl}}/api/v1/user/customer/profile - update
export const getProfile = (data: any) =>
  user.get<User>("/customer/profile", data);

// {{apiUrl}}/api/v1/user/customer/profile - update
export const updateProfile = (data: any) =>
  updatedUser.patch<User>("/customer/profile", data);

// Change Password: /user/customer/profile/password
export const changePassword = (data: {
  password: string;
  oldPassword?: string;
}) => updatedUser.patch<User>("/customer/profile/password", data);

// /user/customer/avatar
export const updateAvatar = (data: any) =>
  updatedUser.post<User>("/customer/avatar/change", data);

// send email: /mail/forget-password/send-email
export const sendResetEmail = (data: { email: string }) =>
  auth.post<{ status: boolean; message: string }>(
    "/forget-password/send-email",
    data
  );

// varify and change password: /mail/forget-password/verify-and-reset
export const verifyAndResetPassword = (data: {
  token: string;
  password: string;
}) => auth.post<any>("/forget-password/verify-and-reset", data);

// moderator login: {{apiUrl}}/auth/admin/moderator/login
export const moderatorLogin = (data: { email: string; password: string }) =>
  new Fetcher().post<any>("auth/admin/moderator/login", data);

// moderator verify OTP: {{apiUrl}}/auth/admin/moderator/verify-otp
export const moderatorVerifyOtp = (data: { userId: number; otp: string }) =>
  new Fetcher().post<any>("auth/admin/moderator/verify-otp", data);
